import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
  providedIn: 'root'
})
export class ManualOrderService {
  public userSessionSubject = new BehaviorSubject(null)
  public authorSessionSubject = new BehaviorSubject(null)

  public clientSessionSubject = new BehaviorSubject(null)

  apiURL = "https://api.wia.id/api/channel/"
  account_id: any
  customer: any
  client_id: any;
  author_id: any;
  constructor(
    private http: HttpClient
  ) { }






  //CREATOR START



  async uploadPhoto(formvalue, dir_name) {




    let res = await fetch(this.apiURL + 'upload/' + dir_name, {

      method: "POST",
      // headers: { 'Content-Type': 'application/json' },
      body: formvalue //JSON.stringify(formvalue)

    })

    let data = await res.json()
    return data

  }



  async channelProductUpdate(formvalue, id) {

    let res = await fetch(this.apiURL + 'product/' + id + '/update', {
      method: "PATCH",
      body: JSON.stringify(formvalue),
      headers: { 'Content-Type': 'application/json' }


    })
    let data = await res.json()
    if (data.status_code != 200) throw data.message_code
    else {
      return data
    }
  }


  async channelCategoryUpdate(formvalue, id) {

    let res = await fetch(this.apiURL + 'category/' + id + '/update', {
      method: "PATCH",
      body: JSON.stringify(formvalue),
      headers: { 'Content-Type': 'application/json' }


    })
    let data = await res.json()
    if (data.status_code != 200) throw data.message_code
    else {
      return data
    }
  }


  async addProduct(formvalue) {

    let res = await fetch(this.apiURL + 'product/add', {
      method: "POST",
      body: JSON.stringify(formvalue),
      headers: { 'Content-Type': 'application/json' }


    })
    let data = await res.json()
    if (data.status_code != 200) throw data.message_code
    else {
      return data
    }
  }



  async addCategory(formvalue) {

    let res = await fetch(this.apiURL + 'category/add', {
      method: "POST",
      body: JSON.stringify(formvalue),
      headers: { 'Content-Type': 'application/json' }


    })
    let data = await res.json()
    if (data.status_code != 200) throw data.message_code
    else {
      return data
    }
  }

  async addChannelCategoryProduct(cat_id, formvalue) {

    let res = await fetch(this.apiURL + 'category/' + cat_id + '/product/add', {
      method: "POST",
      body: JSON.stringify(formvalue),
      headers: { 'Content-Type': 'application/json' }


    })
    let data = await res.json()
    if (data.status_code != 200) throw data.message_code
    else {
      return data
    }
  }

  async deleteChannelCategoryProduct(cat_id, formvalue) {

    let res = await fetch(this.apiURL + 'category/' + cat_id + '/product/delete', {
      method: "POST",
      body: JSON.stringify(formvalue),
      headers: { 'Content-Type': 'application/json' }


    })
    let data = await res.json()
    if (data.status_code != 200) throw data.message_code
    else {
      return data
    }
  }







  async getProduct(query?) {

    let res = await fetch(this.apiURL + 'product' + query, {
      method: "GET",


    })
    let data = await res.json()
    if (data.status_code != 200) throw data.message_code
    else {
      return data
    }
  }



  async getCategory(query?) {

    let res = await fetch(this.apiURL + 'category' + query, {
      method: "GET",


    })
    let data = await res.json()
    if (data.status_code != 200) throw data.message_code
    else {
      return data
    }
  }


  async getCategoryProduct(id) {

    let res = await fetch(this.apiURL + 'category/' + id + '/product', {
      method: "GET",


    })
    let data = await res.json()
    if (data.status_code != 200) throw data.message_code
    else {
      return data
    }
  }







}
